import { Component } from 'preact';
import PropTypes from 'prop-types';

export default class RangeInput extends Component {
  constructor(props) {
    super(props);
    this.updatePercentageBar = this.updatePercentageBar.bind(this);
    this.addCurrencyFormat = this.addCurrencyFormat.bind(this);
  }

  componentDidUpdate() {
    this.updatePercentageBar();
  }

  updatePercentageBar() {
    const percentage = (this.props.value / this.props.max) * 100;
    const value = percentage || 0;
    this.inputRef.style.setProperty('--percentage', `${value}%`);
  }

  addCurrencyFormat(value) {
    const currencyValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `R$ ${currencyValue}`;
  }

  render() {
    return (
      <div
        // eslint-disable-next-line no-return-assign
        ref={ref => (this.inputRef = ref)}
        className={`range-input ${this.props.disabled && 'disabled'}`}
      >
        <div className="range-input__label-container">
          <div className="range-input__label">
            {this.addCurrencyFormat(this.props.value.toString())}
          </div>
        </div>

        <input
          type="range"
          step={100}
          className="range-input__input"
          {...this.props}
        />
      </div>
    );
  }
}

RangeInput.defaultProps = {
  value: 0,
  min: 0,
  max: 100000,
  disabled: false,
};

RangeInput.propTypes = {
  value: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
};
